export const SECTION_NAME = {
  business_report: 'Business report',
  cohorted_analytics: 'Cohorted Analytics',
}
